export default "__VITE_ASSET__K0gv8Tzl__"